import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Bots from './pages/Bots';
import Users from './pages/Users';
import News from './pages/News';
import Analytics from './pages/Analytics';
import Campaigns from './pages/Campaigns';
import PostHogAnalytics from './pages/PostHogAnalytics';
import Settings from './pages/Settings';
import ManualNews from './pages/ManualNews';
import Subscriptions from './pages/Subscriptions';
import Group from './pages/Group';
import AdminUsers from './pages/AdminUsers';
import Certificates from './pages/Certificates';
import PaymentLogs from './pages/PaymentLogs';
import Feedback from './pages/Feedback';
import Complaints from './pages/Complaints';
import MiniAppSettings from './pages/MiniAppSettings';
import AppManagement from './pages/AppManagement';
import { AuthProvider, useAuth } from './context/AuthContext';

// Защищённый маршрут
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="loading" style={{ height: '100vh' }}>
        <div className="spinner"></div>
        <span>Загрузка...</span>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

// Основной Layout приложения
function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  
  return (
    <div className="app-container">
      <Sidebar 
        collapsed={sidebarCollapsed} 
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} 
      />
      <div className="main-content">
        <Header />
        <div className="page-content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/bots" element={<Bots />} />
            <Route path="/users" element={<Users />} />
            <Route path="/news" element={<News />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/trackers" element={<Campaigns />} />
            <Route path="/campaigns" element={<Navigate to="/trackers" replace />} />
            <Route path="/posthog" element={<PostHogAnalytics />} />
            <Route path="/manual-news" element={<ManualNews />} />
            <Route path="/subscriptions" element={<Subscriptions />} />
            <Route path="/payment-logs" element={<PaymentLogs />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/complaints" element={<Complaints />} />
            <Route path="/group" element={<Group />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/miniapp-settings" element={<MiniAppSettings />} />
            <Route path="/certificates" element={<Certificates />} />
            <Route path="/admin-users" element={<AdminUsers />} />
            <Route path="/app-management" element={<AppManagement />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route 
            path="/*" 
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
